import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button, TextField, Typography, Container, FormControl, Select, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";

function CreateUser(roleUser) {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [role, setRole] = useState("");
  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(process.env.REACT_APP_DOMAIN_URL+"/createUser",
    {
        email,
        username,
        role,
      },
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`
        },
      },
    );

      if (!roleUser) {
        setError(response.data.error || "Erreur inconnue");
      }
      if (response.status === 200) {
        setSuccess("Utilisateur créé avec succès !");
        setTimeout(() => navigate("/dashboard"), 3000);
      }
    } catch (error) {
      if (error.response && error.response.data) {
        setError(error.response.data.error || "Erreur de connexion au serveur");
      } else {
        setError("Erreur de connexion au serveur");
      }
    }
  };

  return (
    <Container component="main" maxWidth="xs" className="logContainer">
      <div className="logContainerChild">
        <Typography component="h1" variant="h5">
          Créer un utilisateur
        </Typography>
        {error && <p className="error-message">{error}</p>}
        {success && <p style={{ color: "green" }}>{success}</p>}
        <form onSubmit={handleSubmit}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="email"
            label="Adresse mail"
            id="email"
            autoComplete="email"
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="username"
            label="Nom d'utilisateur"
            name="username"
            autoComplete="username"
            autoFocus
            onChange={(e) => setUsername(e.target.value)}
          />
          <FormControl fullWidth margin="normal">
            <Select
              required
              value={role}
              onChange={(e) => setRole(e.target.value)}
              displayEmpty
            >
              <MenuItem value="" disabled>
                Choisir son role
              </MenuItem>
              <MenuItem value="onet">Onet</MenuItem>
              <MenuItem value="compass">Compass</MenuItem>
            </Select>
          </FormControl>
          <Button type="submit" fullWidth variant="contained" color="primary" sx={{ mt: 3 }}>
            Créer
          </Button>
        </form>
      </div>
    </Container>
  );
}

export default CreateUser;
